(function ($) {
  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);

  function init() {
    modifyProductInCartInit();
  }

  function modifyProductInCartInit() {
    if (window.location.search.indexOf("&modifyProduct=") === -1) return;
    var keyId = window.location.search.split("&modifyProduct=")[1];
    keyId = keyId.split("&")[0];
    var addToCartBtn = $(".cpb-add-to-cart-button");
    addToCartBtn.find("span").html("Update Cart");
    addToCartBtn.on("click", function () {
      $.post("/cart/change.js", {
        id: keyId,
        quantity: 0,
      });
    });
  }
})(jQuery);
